var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart",
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.49 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.25,
    y1: 50.17,
    x2: 28.25,
    y2: 34.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c7c6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a8a6a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#817f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#555252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.36,
    y1: 44.28,
    x2: 43.36,
    y2: 3.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e8232a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d32128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c82026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b61f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ab1f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a81f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13.14,
    y1: 38.29,
    x2: 13.14,
    y2: 5.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e8232a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d32128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c82026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b61f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ab1f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a81f23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.54,46.33s-11.85-7.01-13.12-7.64c-.45-.23-.85-.29-1.18-.28-.33-.01-.73,.05-1.18,.28-1.27,.63-13.12,7.64-13.12,7.64,0,0-.56,.27-.62,.72,.06,.45,.62,.72,.62,.72,0,0,11.85,7.01,13.12,7.64,.45,.23,.85,.29,1.18,.28,.33,.01,.73-.05,1.18-.28,1.27-.63,13.12-7.64,13.12-7.64,0,0,.56-.27,.62-.72-.06-.45-.62-.72-.62-.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.18,11.82L33.74,.73s-3.05-2.24-3.05,1.12V24.24s-.31,3.36,2.75,5.29l20.15,11.7s2.44,1.83,2.44-1.93V17.42s.41-3.66-2.85-5.6Zm-2.58,15.84c-.58,.95-2,.54-2,.54-2.24-.54-4.21-3.12-4.21-3.12,.58,2.82,2.31,5.33,2.31,5.33v.71l-6.34-3.87,.03-.61c2.34-.44,2.17-2.71,2.17-2.71-1.59,.37-5.12-1.56-6.38-5.12-1.25-3.56,2.37-4.1,2.37-4.1,3.97-.58,5.05-2.95,5.05-2.95,0,0,1.59,4.51,3.6,7.06,1.69,2.15,2.75,3.77,3.39,5.29,.39,.92,.58,2.61,0,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.21,18.81c-2-2.54-3.6-7.06-3.6-7.06,0,0-1.09,2.37-5.05,2.95,0,0-3.63,.54-2.37,4.1,1.25,3.56,4.78,5.49,6.38,5.12,0,0,.17,2.27-2.17,2.71l-.03,.61,6.34,3.87v-.71s-1.73-2.51-2.31-5.33c0,0,1.97,2.58,4.21,3.12,0,0,1.42,.41,2-.54,.58-.95,.39-2.64,0-3.56-.64-1.53-1.7-3.14-3.39-5.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.81,24.24V1.85c0-3.36-3.05-1.12-3.05-1.12L3.32,11.82C.07,13.76,.47,17.42,.47,17.42v21.88c0,3.77,2.44,1.93,2.44,1.93l20.15-11.7c3.05-1.93,2.75-5.29,2.75-5.29Zm-6.1-6.11c-.72,1.3-6.57,9.75-6.57,9.75,0,0-3.71,.33-6.46-1.91-2.75-2.24,0-6.82,0-6.82,2.65-4.58,6.45-3.66,6.45-3.66,3.61-5.7,6.58-3.87,6.58-3.87,1.87,.64,1.09,4.55,0,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.69,25.97c2.75,2.24,6.46,1.91,6.46,1.91,0,0,5.85-8.45,6.57-9.75,1.09-1.97,1.87-5.87,0-6.51,0,0-2.97-1.83-6.58,3.87,0,0-3.8-.92-6.45,3.66,0,0-2.75,4.58,0,6.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.55ee51cc526ffed96e03a0cf0497c9b5.svg";
export { ForwardRef as ReactComponent };